/*
 * Created Date: 16-08-2022, 4:17:00 pm
 * Author: Peter
 * Email: phantrung696@gmail.com
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2022 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import React, { useContext } from 'react'
// import PropTypes from 'prop-types'
const CorePageContext = React.createContext()

export const useCorePageContext = () => useContext(CorePageContext)

const CorePageProvider = props => {
	return <CorePageContext.Provider value={props}>{props.children}</CorePageContext.Provider>
}

// CorePageProvider.defaultProps = {}

// CorePageProvider.propTypes = {}

export default React.memo(CorePageProvider)
